import {
  STATUS_REPORT_OFF,
  StatusReportTemplateKey,
  type UserStatusReportSelection,
} from "@forgepoint/shared";
import { SelectItem } from "@/components/ui/select";
import { SELECTION_LABELS } from "./statusReportSelectionOptions";

/**
 * The option items for a status-report selection picker: the org-enabled
 * templates — plus the current selection so a since-disabled choice stays
 * visible, suffixed "(disabled)" — followed by Off.
 */
export function StatusReportSelectItems({
  enabledTemplateKeys,
  currentSelection,
}: {
  enabledTemplateKeys: StatusReportTemplateKey[] | null;
  currentSelection: UserStatusReportSelection | undefined;
}) {
  const isEnabled = (templateKey: StatusReportTemplateKey) =>
    enabledTemplateKeys === null || enabledTemplateKeys.includes(templateKey);
  const templateOptions = Object.values(StatusReportTemplateKey).filter(
    (templateKey) => isEnabled(templateKey) || templateKey === currentSelection,
  );

  return (
    <>
      {templateOptions.map((templateKey) => (
        <SelectItem key={templateKey} value={templateKey}>
          {SELECTION_LABELS[templateKey]}
          {!isEnabled(templateKey) && " (disabled)"}
        </SelectItem>
      ))}
      <SelectItem value={STATUS_REPORT_OFF}>
        {SELECTION_LABELS[STATUS_REPORT_OFF]}
      </SelectItem>
    </>
  );
}
